'use client';
import useToastStore from '@/stores/ui/toast';

export default function SoopUiToast() {
  const toastList = useToastStore((state) => {
    return state.toastList.reverse();
  });

  return (
    <div className='toast-box'>
      {toastList.map((toast, index) => {
        return (
          <div key={index} className={toast.className}>
            {!toast.children ? (
              <p dangerouslySetInnerHTML={{__html: toast.message}} />
            ) : (
              <>{toast.children}</>
            )}
          </div>
        );
      })}
    </div>
  );
}
